/* eslint-disable max-len, react/jsx-max-props-per-line, react/jsx-sort-props */
import React from "react";

const ValidationCheckmark = () => (
  <div className="validation-checkmark">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16.5" cy="15.5" r="12.5" fill="#009E2C" />
      <path fillRule="evenodd" clipRule="evenodd" d="M22.717 10.1351C23.0275 10.3607 23.0925 10.7902 22.8621 11.0943L14.8122 21.7229C14.6833 21.8929 14.4815 21.9952 14.2654 21.9998C14.0493 22.0045 13.843 21.9111 13.7067 21.7467L9.15674 16.261C8.91296 15.9671 8.95856 15.5352 9.25861 15.2964C9.55865 15.0576 9.99951 15.1023 10.2433 15.3962L14.2249 20.1966L21.7378 10.2772C21.9681 9.97304 22.4066 9.90941 22.717 10.1351Z" fill="white" />
    </svg>
  </div>
);

export default ValidationCheckmark;
